import { getAccessToken } from "../api/auth.js";

const ACTIVE_RESEARCH_KEY = "bms_active_research_id";

let currentResearchId = null;

export function getCurrentResearchId() {
  return currentResearchId;
}

export function setCurrentResearchId(newId) {
  const normalizedId = newId || null;
  const hasChanged = currentResearchId !== normalizedId;
  currentResearchId = normalizedId;

  if (currentResearchId) {
    localStorage.setItem(ACTIVE_RESEARCH_KEY, currentResearchId);
    if (hasChanged) {
      console.log("[Research] Active research session set to:", currentResearchId);
    }
  } else {
    localStorage.removeItem(ACTIVE_RESEARCH_KEY);
    if (hasChanged) {
      console.log("[Research] Active research session cleared");
    }
  }
}

export function restoreActiveResearchIdFromStorage() {
  const storedActiveResearchId = localStorage.getItem(ACTIVE_RESEARCH_KEY);
  if (storedActiveResearchId) {
    setCurrentResearchId(storedActiveResearchId);
    console.log("[Research] Restored active research session from local storage:", storedActiveResearchId);
  }
}

export async function clearActiveResearchIdOnServer() {
  const token = getAccessToken();
  if (!token) return;

  try {
    const response = await fetch("/api/auth/active-research/clear", {
      method: "POST",
      headers: {
        "X-Access-Token": token,
      },
    });
    if (!response.ok) {
      console.warn("[Research] Failed to clear active research on server:", response.status);
    }
  } catch (error) {
    console.error("[Research] Error clearing active research on server:", error);
  }
}

